import { useAuth } from '@/src/contexts';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/src/helpers';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  Button,
  Input,
  FormMessage,
} from '@/src/ui-components';
import { toast } from 'sonner';
import { FormSchema, formSchema } from '../../shared';

export const SignInForm = () => {
  const navigate = useNavigate();
  const { signInWithPassword, loading } = useAuth();

  const form = useForm<FormSchema>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const onSubmit = async ({ email, password }: FormSchema) => {
    const { error } = await signInWithPassword({ email, password });
    if (error) {
      toast.error('Error signing in', {
        description: error,
      });
      return;
    }
    navigate('/trading', { replace: true });
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="w-full space-y-6">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email Address</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Enter your email" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Password</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  type="password"
                  placeholder="Enter your password"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button
          type="submit"
          disabled={loading}
          className={cn(
            'h-12 w-full transform rounded-lg bg-gradient-to-r from-primary to-primary/80 font-medium text-primary-foreground transition-all duration-200 hover:scale-[1.02] hover:from-primary/90 hover:to-primary/70 disabled:transform-none',
            loading && 'opacity-50'
          )}
        >
          {loading ? 'Signing In' : 'Sign In'}
        </Button>
      </form>
    </Form>
  );
};
